import {showError} from '../../../Messages/actions';
import {priority} from '@priority-software/priority-proto-api/lib';
import {APIActionStatus} from '../../../../stores/Form';

export const handleBatchCriticalError = async (
    res: priority.netitems.form.INet2Grpc,
    session: string = ''
) => {
    if (res.FatalError) {
        return await showError(
            session,
            {
                Messages: [
                    new priority.netitems.shared.Message({
                        MType: priority.netitems.shared.Message.Type.Fatal,
                        Text: res.FatalError?.error
                    })
                ]
            },
            true
        );
    }

    return Promise.resolve(APIActionStatus.passed);
};
